import { render, staticRenderFns } from "./of_upload.vue?vue&type=template&id=19d63f30&scoped=true&"
import script from "./of_upload.vue?vue&type=script&lang=js&"
export * from "./of_upload.vue?vue&type=script&lang=js&"
import style0 from "./of_upload.vue?vue&type=style&index=0&id=19d63f30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d63f30",
  null
  
)

export default component.exports